import { toast } from '../design/components/Toast';

function getOrigin() {
  if (typeof window === 'undefined') return '';
  return window.location.origin;
}

async function copyText(text) {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return true;
  }
  const area = document.createElement('textarea');
  area.value = text;
  area.style.position = 'fixed';
  area.style.left = '-9999px';
  document.body.appendChild(area);
  area.focus();
  area.select();
  const ok = document.execCommand('copy');
  document.body.removeChild(area);
  return ok;
}

export async function sharePet(pet = {}, opts = {}) {
  const id = pet.id || pet.animal_id;
  const name = pet.name || 'น้องน่ารัก';
  const url = opts.url || `${getOrigin()}/v2/animal/${id || ''}`;
  const shareData = {
    title: `มาดูน้อง ${name} บน TailLink`,
    text: `เจอน้อง ${name} น่ารักมากบน TailLink 🐾`,
    url,
  };
  try {
    if (navigator.share) {
      await navigator.share(shareData);
      toast('แชร์ให้น้องแล้ว ✨');
      return true;
    }
    await copyText(url);
    toast('คัดลอกลิงก์น้องแล้ว ✨');
    return true;
  } catch (error) {
    if (error?.name === 'AbortError') return false;
    toast('แชร์ไม่สำเร็จ ลองใหม่อีกครั้งนะ', { tone: 'error' });
    return false;
  }
}

// Share link specifically tuned for the boost loop. The ?ref=boost flag tells
// the destination profile to immediately surface the "💪 ดันลูก" CTA so the
// friend who opens the link can boost in one tap.
export async function shareBoost(pet = {}) {
  const id = pet.id || pet.animal_id;
  const name = pet.name || 'น้องน่ารัก';
  const url = `${getOrigin()}/v2/animal/${id || ''}?ref=boost`;
  const shareData = {
    title: `ช่วยดันน้อง ${name} ขึ้นมงด้วย!`,
    text: `น้อง ${name} กำลังลุ้นมงน้องน่ารักของชุมชน 👑 ช่วยดันให้หน่อย — กดเดียวเสร็จ 🐾`,
    url,
  };
  try {
    if (navigator.share) {
      await navigator.share(shareData);
      toast('แชร์ลิงก์ดันแล้ว 💪');
      return true;
    }
    await copyText(url);
    toast('คัดลอกลิงก์ดันแล้ว ส่งให้เพื่อนช่วยกดได้เลย! 💪');
    return true;
  } catch (error) {
    if (error?.name === 'AbortError') return false;
    toast('แชร์ไม่สำเร็จ ลองใหม่อีกครั้งนะ', { tone: 'error' });
    return false;
  }
}

export async function shareApp() {
  const url = `${getOrigin()}/v2`;
  try {
    if (navigator.share) {
      await navigator.share({
        title: 'TailLink',
        text: 'มาดูน้องๆ ใกล้บ้านบน TailLink กัน 🐾',
        url,
      });
      toast('แชร์ TailLink แล้ว ✨');
      return true;
    }
    await copyText(url);
    toast('คัดลอกลิงก์ TailLink แล้ว ✨');
    return true;
  } catch (error) {
    if (error?.name === 'AbortError') return false;
    toast('แชร์ไม่สำเร็จ ลองใหม่อีกครั้งนะ', { tone: 'error' });
    return false;
  }
}

export async function shareChallenge(challenge = {}) {
  const slug = challenge.slug || 'orange-cat-day';
  const title = challenge.title || 'ภารกิจชุมชน TailLink';
  const url = `${getOrigin()}/v2/challenges/${slug}`;
  try {
    if (navigator.share) {
      await navigator.share({
        title: `${title} บน TailLink`,
        text: `มาเล่น ${title} กัน 🐾 ออกไปเจอน้องจริง แล้วแชร์ให้คนรักสัตว์ดูด้วยกัน`,
        url,
      });
      toast('แชร์ภารกิจแล้ว ✨');
      return true;
    }
    await copyText(url);
    toast('คัดลอกลิงก์ภารกิจแล้ว ✨');
    return true;
  } catch (error) {
    if (error?.name === 'AbortError') return false;
    toast('แชร์ไม่สำเร็จ ลองใหม่อีกครั้งนะ', { tone: 'error' });
    return false;
  }
}

export async function shareStampHunt(hunt = {}) {
  const slug = hunt.slug || 'lumpini-cat-stamp-hunt';
  const title = hunt.title || 'ล่าแสตมป์ TailLink';
  const url = `${getOrigin()}/v2/stamp-hunts/${slug}`;
  try {
    if (navigator.share) {
      await navigator.share({
        title: `${title} บน TailLink`,
        text: `มาเก็บแสตมป์น้องๆ ใน ${hunt.area_name || 'ชุมชน'} ด้วยกัน 🐾`,
        url,
      });
      toast('แชร์สมุดแสตมป์แล้ว ✨');
      return true;
    }
    await copyText(url);
    toast('คัดลอกลิงก์เกมแสตมป์แล้ว ✨');
    return true;
  } catch (error) {
    if (error?.name === 'AbortError') return false;
    toast('แชร์ไม่สำเร็จ ลองใหม่อีกครั้งนะ', { tone: 'error' });
    return false;
  }
}